import angular from 'angular';

angular.module('application').directive('ngEnter', function() {
    return function(scope, element, attrs) {
        element.on("keydown keypress", function(event) {
            if (event.which === 13) {
                scope.$apply(function() {
                    scope.$eval(attrs.ngEnter, {
                        'event': event
                    });
                });

                event.preventDefault();
            }
        });
    };
});